// @ts-nocheck
// @ts-ignore

import { Component } from '@theme/component';
import { CartAddEvent } from '@theme/events';

const NEO_PLAY_ICON_SVG = `<svg class="neo-product-card-1-watch-play-icon" width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<foreignObject x="-9.14844" y="-9.14844" width="24.5459" height="26.1479"><div xmlns="http://www.w3.org/1999/xhtml" style="backdrop-filter:blur(4.57px);clip-path:url(#bgblur_0_6163_3766_clip_path);height:100%;width:100%"></div></foreignObject><path data-figma-bg-blur-radius="9.14844" d="M0 7.08734V0.735669C0 0.149096 0.653735 -0.200773 1.14179 0.124599L5.90983 3.30329C6.36248 3.60505 6.36248 4.27019 5.90983 4.57195L1.18526 7.72167C0.67862 8.05943 0 7.69624 0 7.08734Z" fill="white"/>
<defs>
<clipPath id="bgblur_0_6163_3766_clip_path" transform="translate(9.14844 9.14844)"><path d="M0 7.08734V0.735669C0 0.149096 0.653735 -0.200773 1.14179 0.124599L5.90983 3.30329C6.36248 3.60505 6.36248 4.27019 5.90983 4.57195L1.18526 7.72167C0.67862 8.05943 0 7.69624 0 7.08734Z"/>
</clipPath></defs>
</svg>`;

const PRODUCT_QUERIES = `
  title
  handle
  id
  availableForSale
  productType
  tags
  handle
  description
  priceRange {
    maxVariantPrice { amount }
    minVariantPrice { amount }
  }
  variants(first: 1) {
    edges {
      node {
        id
        price { amount }
        compareAtPrice { amount }
      }
    }
  }
  featuredImage {
    url
    altText
    width
    height
  }
  images(first: 5) {
    nodes {
      url
      altText
      width
      height
    }
  }
  metafield_tag: metafield(namespace: "neo", key: "usage_tag") {
    value
  }
  metafield_highlights: metafield(namespace: "neo", key: "highlights") {
    value
  }
  metafield_watch_gif: metafield(namespace: "neo", key: "watch_gif") {
    reference {
      ... on MediaImage {
        image { url }
      }
    }
  }
  metafield_color_variants: metafield(namespace: "custom", key: "color_variants") {
    references(first: 10) {
      nodes {
        ... on Product {
          id
          availableForSale
          metafield_color_swatch_image: metafield(namespace: "custom", key: "color_swatch_image") {
            reference {
              ... on MediaImage {
                image { url }
              }
            }
          }
        }
      }
    }
  }
`;
export class SimilarProducts extends Component {
  #MAX_PRODUCTS = 25;
  #MAX_PRODUCTS_FROM_LIST = 10; // Limit for product list metafield
  #MAX_PRODUCTS_FROM_COLLECTION = 10; // Limit for collection metafield
  #MIN_PRODUCTS_TO_SHOW = 1;
  #API_LIMIT = 10;

  connectedCallback() {
    super.connectedCallback();
    this.#initialize();
  }

  #initialize() {
    // Try to find container - it might be inside swiper-component
    const container = this.refs.container || this.querySelector('[ref="container"]') || this.querySelector('.similar-products__list');
    if (!container) {
      setTimeout(() => this.#initialize(), 10);
      return;
    }

    // Store container reference if not found via refs
    if (!this.refs.container && container) {
      this.refs.container = container;
    }

    // Priority 1: Check for collection metafield
    const collectionId = this.dataset.collectionId;
    const collectionHandle = this.dataset.collectionHandle;

    if (collectionId || collectionHandle) {
      this.#fetchProductsFromCollection(collectionId || null, collectionHandle || null);
      return;
    }

    // Priority 2: Check for product list metafield
    const productIds = this.dataset.productIds;
    if (productIds) {
      const productIdArray = productIds.split(',').filter(id => id.trim());
      if (productIdArray.length > 0) {
        this.#fetchProductsByIds(productIdArray);
        return;
      }
    }

    // No metafield data - hide section
    this.#hideSection();
  }

  /**
   * Fetches products from a collection via GraphQL
   * @param {string | null} collectionId - Collection ID (GID format)
   * @param {string | null} collectionHandle - Collection handle (fallback)
   */
  async #fetchProductsFromCollection(collectionId, collectionHandle) {

    try {
      const root = /** @type {any} */ (window.Shopify)?.routes?.root || '/';
      const graphqlEndpoint = `${root}api/2024-01/graphql.json`;
      const accessToken = window.storefrontAccessToken;

      if (!graphqlEndpoint || !accessToken) {
        this.#hideSection();
        return;
      }

      // Build collection ID (GID format)
      let collectionGid = collectionId;
      if (collectionGid && !collectionGid.includes('gid://')) {
        collectionGid = `gid://shopify/Collection/${collectionGid}`;
      } else if (collectionHandle) {
        // If we only have handle, we'll need to query by handle
        collectionGid = null;
      }

      const query = collectionGid
        ? this.#buildCollectionQueryById(collectionGid)
        : (collectionHandle ? this.#buildCollectionQueryByHandle(collectionHandle) : null);

      if (!query) {
        this.#hideSection();
        return;
      }

      const response = await fetch(graphqlEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': accessToken,
        },
        body: JSON.stringify({ query }),
      });

      if (!response.ok) {
        this.#hideSection();
        return;
      }

      const data = await response.json();
      if (data.errors) {
        this.#hideSection();
        return;
      }

      let products = [];
      if (collectionGid && data.data?.collection?.products?.nodes) {
        products = data.data.collection.products.nodes;
      } else if (collectionHandle && data.data?.collectionByHandle?.products?.nodes) {
        products = data.data.collectionByHandle.products.nodes;
      }

      // Filter available products and limit to MAX_PRODUCTS
      products = products
        .filter((/** @type {any} */ p) => p.availableForSale !== false)
        .slice(0, this.#MAX_PRODUCTS);

      if (products.length < this.#MIN_PRODUCTS_TO_SHOW) {
        this.#hideSection();
        return;
      }

      // Map GraphQL products to expected format
      const mappedProducts = products.map((/** @type {any} */ p) => this.#mapGraphQLProduct(p));

      const enrichedProducts = await this.#enrichProducts(mappedProducts);

      if (enrichedProducts.length < this.#MIN_PRODUCTS_TO_SHOW) {
        this.#hideSection();
        return;
      }

      this.#renderProducts(enrichedProducts);
    } catch {
      this.#hideSection();
    }
  }

  /**
   * Fetches products by IDs from product list metafield
   * @param {string[]} productIds - Array of product IDs
   */
  async #fetchProductsByIds(productIds) {
    try {
      const root = /** @type {any} */ (window.Shopify)?.routes?.root || '/';
      const graphqlEndpoint = `${root}api/2024-01/graphql.json`;
      const accessToken = window.storefrontAccessToken;

      if (!graphqlEndpoint || !accessToken) {
        this.#hideSection();
        return;
      }

      // Limit to MAX_PRODUCTS_FROM_LIST (15 for product list)
      const limitedIds = productIds.slice(0, this.#MAX_PRODUCTS_FROM_LIST);
      const productGids = limitedIds.map(id => {
        // Convert to GID format if needed
        if (id.includes('gid://')) {
          return id;
        }
        return `gid://shopify/Product/${id}`;
      });

      const query = this.#buildProductsByIdsQuery(productGids);
      const response = await fetch(graphqlEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': accessToken,
        },
        body: JSON.stringify({ query }),
      });

      if (!response.ok) {
        this.#hideSection();
        return;
      }

      const data = await response.json();

      if (data.errors) {
        this.#hideSection();
        return;
      }

      // Extract products from GraphQL response
      const products = [];
      for (let i = 0; i < productGids.length; i++) {
        const nodeKey = `node${i}`;
        const product = data.data?.[nodeKey];
        if (product && product.availableForSale !== false) {
          products.push(this.#mapGraphQLProduct(product));
        }
      }

      // Ensure we have up to MAX_PRODUCTS_FROM_LIST (15) products
      const finalProducts = products.slice(0, this.#MAX_PRODUCTS_FROM_LIST);

      if (finalProducts.length < this.#MIN_PRODUCTS_TO_SHOW) {
        this.#hideSection();
        return;
      }

      const enrichedProducts = await this.#enrichProducts(finalProducts);

      if (enrichedProducts.length < this.#MIN_PRODUCTS_TO_SHOW) {
        this.#hideSection();
        return;
      }

      this.#renderProducts(enrichedProducts);
    } catch {
      this.#hideSection();
    }
  }

  /**
   * @param {any[]} products
   * @returns {Promise<any[]>}
   */
  async #enrichProducts(products) {
    const root = /** @type {any} */ (window.Shopify)?.routes?.root || '/';
    const graphqlEndpoint = `${root}api/2024-01/graphql.json`;
    const accessToken = window.storefrontAccessToken;

    if (!graphqlEndpoint || !accessToken) {
      return products.map(p => this.#mapProduct(p));
    }

    try {
      const productIds = products.map(p => `gid://shopify/Product/${p.id}`);
      const query = this.#buildGraphQLQuery(productIds);

      const response = await fetch(graphqlEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': accessToken,
        },
        body: JSON.stringify({ query }),
      });

      if (!response.ok) {
        return products.map(p => this.#mapProduct(p));
      }

      const data = await response.json();

      return products.map((product, index) => {
        const nodeKey = `node${index}`;
        const graphqlProduct = data.data?.[nodeKey];

        if (graphqlProduct) {
          return this.#mapProductWithMetafields(product, graphqlProduct);
        }

        return this.#mapProduct(product);
      });
    } catch {
      return products.map(p => this.#mapProduct(p));
    }
  }

  /**
   * Builds GraphQL query to fetch collection by ID
   * @param {string} collectionGid
   * @returns {string}
   */
  #buildCollectionQueryById(collectionGid) {
    return `{
      collection(id: "${collectionGid}") {
        products(first: ${this.#MAX_PRODUCTS_FROM_COLLECTION}) {
          nodes {
            ${PRODUCT_QUERIES}
          }
        }
      }
    }`;
  }

  /**
   * Builds GraphQL query to fetch collection by handle
   * @param {string} collectionHandle
   * @returns {string}
   */
  #buildCollectionQueryByHandle(collectionHandle) {
    return `{
      collectionByHandle(handle: "${collectionHandle}") {
        products(first: ${this.#MAX_PRODUCTS_FROM_COLLECTION}) {
          nodes {
            ${PRODUCT_QUERIES}
          }
        }
      }
    }`;
  }

  /**
   * Builds GraphQL query to fetch multiple products by IDs
   * @param {string[]} productGids
   * @returns {string}
   */
  #buildProductsByIdsQuery(productGids) {
    const nodes = productGids
      .map((gid, index) => {
        return `node${index}: node(id: "${gid}") {
          ... on Product {
            ${PRODUCT_QUERIES}
          }
        }`;
      })
      .join('\n');

    return `{
      ${nodes}
    }`;
  }

  /**
   * Maps GraphQL product to expected format
   * @param {any} graphqlProduct
   * @returns {any}
   */
  #mapGraphQLProduct(graphqlProduct) {
    const productId = graphqlProduct.id?.replace('gid://shopify/Product/', '') || '';
    const firstVariant = graphqlProduct.variants?.edges?.[0]?.node;
    const variantId = firstVariant?.id?.replace('gid://shopify/ProductVariant/', '') || '';

    // Get price from variant or priceRange
    let price = 0;
    let currencyCode = 'INR';

    if (firstVariant?.price) {
      price = parseFloat(firstVariant.price.amount);
      currencyCode = firstVariant.price.currencyCode || 'INR';
    } else if (graphqlProduct.priceRange?.minVariantPrice) {
      price = parseFloat(graphqlProduct.priceRange.minVariantPrice.amount);
      currencyCode = graphqlProduct.priceRange.minVariantPrice.currencyCode || 'INR';
    }

    return {
      id: productId,
      title: graphqlProduct.title || '',
      handle: graphqlProduct.handle || '',
      tags: graphqlProduct.tags || [],
      available: graphqlProduct.availableForSale !== false,
      variants: firstVariant ? [{
        id: variantId,
        available: firstVariant.availableForSale !== false,
        price: (price * 100).toString(),
        compare_at_price: firstVariant.compareAtPrice?.amount
          ? (parseFloat(firstVariant.compareAtPrice.amount) * 100).toString()
          : '0',
      }] : [],
      price: (price * 100).toString(),
      compare_at_price: firstVariant?.compareAtPrice?.amount
        ? (parseFloat(firstVariant.compareAtPrice.amount) * 100).toString()
        : '0',
    };
  }

  /**
   * @param {string[]} productIds
   * @returns {string}
   */
  #buildGraphQLQuery(productIds) {
    const nodes = productIds
      .map((id, index) => {
        return `node${index}: node(id: "${id}") {
          ... on Product {
            ${PRODUCT_QUERIES}
          }
        }`;
      })
      .join('\n');

    return `{
      ${nodes}
    }`;
  }

  /**
   * @param {any} product
   * @returns {{url: string, altText: string, width: null, height: null} | null}
   */
  #getFallbackImage(product) {
    // Try product-level image first
    if (product.featured_image) {
      return {
        url: product.featured_image,
        altText: product.title,
        width: null,
        height: null,
      };
    }

    if (product.images && product.images.length > 0) {
      const imageUrl = typeof product.images[0] === 'string'
        ? product.images[0]
        : product.images[0].src || product.images[0].url;
      if (imageUrl) {
        return {
          url: imageUrl,
          altText: product.title,
          width: null,
          height: null,
        };
      }
    }

    if (product.variants && product.variants.length > 0) {
      for (let i = 0; i < product.variants.length; i++) {
        const variant = product.variants[i];

        // Try featured_image first
        if (variant.featured_image) {
          return {
            url: variant.featured_image,
            altText: product.title,
            width: null,
            height: null,
          };
        }

        // Try image property
        if (variant.image) {
          const imageUrl = typeof variant.image === 'string' ? variant.image : variant.image.src || variant.image.url;
          if (imageUrl) {
            return {
              url: imageUrl,
              altText: product.title,
              width: null,
              height: null,
            };
          }
        }
      }
    }

    return null;
  }

  /**
   * @param {any} product
   * @returns {any}
   */
  #mapProduct(product) {
    const fallbackImage = this.#getFallbackImage(product);
    const firstVariant = product.variants && product.variants.length > 0
      ? product.variants.find(/** @type {(v: any) => boolean} */(v) => v.available) || product.variants[0]
      : null;

    const tags = Array.isArray(product.tags) ? product.tags : [];
    return {
      variantId: firstVariant?.id?.toString() || '',
      productId: product.id.toString(),
      title: product.title,
      handle: product.handle,
      price: firstVariant ? (parseInt(firstVariant.price) / 100) : (parseInt(product.price) / 100),
      compareAtPrice: firstVariant?.compare_at_price
        ? (parseInt(firstVariant.compare_at_price) / 100)
        : (product.compare_at_price ? (parseInt(product.compare_at_price) / 100) : 0),
      currencyCode: 'INR',
      availableForSale: product.available && firstVariant?.available !== false,
      image: fallbackImage,
      highlights: '',
      tag: '',
      imageTag: tags.includes('NEW 2026') || tags.includes('new 2026') ? 'NEW' : '',
      saleImageTag: tags.includes('SALE 2026') || tags.includes('sale 2026') ? 'SALE' : '',
    };
  }

  /**
   * @param {any} product
   * @param {any} graphqlProduct
   * @returns {any}
   */
  #mapProductWithMetafields(product, graphqlProduct) {
    const mapped = this.#mapProduct(product);

    if (graphqlProduct?.featuredImage?.url) {
      mapped.image = {
        url: graphqlProduct.featuredImage.url,
        altText: graphqlProduct.featuredImage.altText || product.title,
        width: graphqlProduct.featuredImage.width,
        height: graphqlProduct.featuredImage.height,
      };
    } else if (graphqlProduct?.variants?.edges?.length > 0) {
      for (let i = 0; i < graphqlProduct.variants.edges.length; i++) {
        const variant = graphqlProduct.variants.edges[i].node;
        if (variant?.image?.url) {
          mapped.image = {
            url: variant.image.url,
            altText: variant.image.altText || product.title,
            width: variant.image.width,
            height: variant.image.height,
          };
          break;
        }
      }
    }

    if (Array.isArray(graphqlProduct.tags)) {
      mapped.imageTag = graphqlProduct.tags.includes('NEW 2026') ? 'NEW' : '';
      mapped.saleImageTag = graphqlProduct.tags.some((tag) => String(tag).toLowerCase() === 'sale 2026') ? 'SALE' : '';
    }

    const highlightsMeta = graphqlProduct.metafield_highlights;
    if (highlightsMeta?.value) {
      try {
        const highlightsData = typeof highlightsMeta.value === 'string' ? JSON.parse(highlightsMeta.value) : highlightsMeta.value;
        if (Array.isArray(highlightsData)) {
          mapped.highlights = highlightsData.join(' | ');
        } else {
          mapped.highlights = highlightsMeta.value;
        }
      } catch {
        mapped.highlights = highlightsMeta.value;
      }
    }

    if (graphqlProduct.metafield_tag?.value) {
      mapped.tag = graphqlProduct.metafield_tag.value;
    }

    const gqlCompare = parseFloat(graphqlProduct.variants?.edges?.[0]?.node?.compareAtPrice?.amount);
    if (Number.isFinite(gqlCompare) && gqlCompare > 0) {
      mapped.compareAtPrice = gqlCompare;
    }

    // Watch GIF and video data (matches neo-collection.js logic)
    const mediaEdges = graphqlProduct.media?.edges || [];
    let watchGifSrc = '';
    let videoPreviewUrl = '';
    let videoSourceUrl = '';

    const watchGifImage = graphqlProduct.metafield_watch_gif?.reference?.image?.url;
    if (watchGifImage) {
      watchGifSrc = watchGifImage;
    }

    for (let i = 0; i < mediaEdges.length; i++) {
      const node = mediaEdges[i]?.node;
      if (i <= 2 || !node) continue;
      const isVideo =
        node.mediaContentType === 'VIDEO' ||
        node.__typename === 'Video' ||
        (node.sources && !node.image);
      if (isVideo) {
        if (!watchGifSrc && node.previewImage?.url) {
          watchGifSrc = node.previewImage.url;
        }
        if (node.previewImage?.url) {
          videoPreviewUrl = node.previewImage.url;
        }
        const mp4 = node.sources?.find?.((s) => s.mimeType === 'video/mp4');
        if (mp4?.url) {
          videoSourceUrl = mp4.url;
        }
        break;
      }
    }

    const hasProductVideo = !!mediaEdges.some((e, i) => {
      const n = e?.node;
      return i > 2 && n && (
        n.mediaContentType === 'VIDEO' ||
        n.__typename === 'Video' ||
        (n.sources && !n.image)
      );
    });

    mapped.watchGifSrc = watchGifSrc;
    mapped.videoPreviewUrl = videoPreviewUrl;
    mapped.videoSourceUrl = videoSourceUrl;
    mapped.hasProductVideo = hasProductVideo;

    // Media JSON used by neo-product-card-1 custom element
    const mediaJsonArr = mediaEdges.map((e) => {
      const n = e?.node;
      if (!n) return null;
      const isImage = n.mediaContentType === 'IMAGE' || n.__typename === 'MediaImage' || n.image;
      const isVideo = n.mediaContentType === 'VIDEO' || n.__typename === 'Video' || n.sources;

      if (isImage && n.image) {
        return {
          media_type: 'image',
          preview_image: { url: n.image.url },
          sources: [],
        };
      }

      if (isVideo) {
        return {
          media_type: 'video',
          preview_image: n.previewImage ? { url: n.previewImage.url } : null,
          sources: (n.sources || []).map((s) => ({
            mime_type: s.mimeType,
            url: s.url,
          })),
        };
      }

      return null;
    }).filter(Boolean);

    mapped.productMediaJson = JSON.stringify(mediaJsonArr).replace(/'/g, '&#39;');

    // Color variant swatches and IDs
    const colorVariantRefs = graphqlProduct.metafield_color_variants?.references?.nodes || [];
    const swatches = [];
    for (const node of colorVariantRefs) {
      if (swatches.length >= 4) break;
      if (!node?.availableForSale) continue;
      const imgRef = node.metafield_color_swatch_image?.reference?.image?.url;
      if (imgRef) {
        swatches.push({ url: imgRef, alt: mapped.title });
      }
    }

    mapped.colorSwatches = swatches;
    mapped.colorVariantIds = colorVariantRefs
      .map((n) => (n?.id || '').replace('gid://shopify/Product/', ''))
      .filter(Boolean)
      .join(',');

    return mapped;
  }

  /**
   * @param {any[]} products
   */
  #renderProducts(products) {
    let container = this.refs.container;
    if (!container || Array.isArray(container)) {
      const foundContainer = this.querySelector('[ref="container"]') || this.querySelector('.similar-products__list') || this.querySelector('.swiper-wrapper');
      if (foundContainer && !Array.isArray(foundContainer)) {
        container = foundContainer;
      }
    }
    if (!container || Array.isArray(container)) {
      console.error('SimilarProducts: Container not found');
      return;
    }

    const containerEl = /** @type {HTMLElement} */ (container);

    const fragment = document.createDocumentFragment();
    products.forEach((/** @type {any} */ product) => {
      const card = this.#createProductCard(product);
      // Wrap card in swiper-slide
      const slide = document.createElement('div');
      slide.className = 'swiper-slide similar-products-slide';
      slide.appendChild(card);
      fragment.appendChild(slide);
    });

    containerEl.innerHTML = '';
    containerEl.appendChild(fragment);
    this.style.display = 'block';
    // Reload SmartWishlist SDK after products are rendered
    if (typeof ReloadSmartWishlist === 'function') {
      setTimeout(() => {
        ReloadSmartWishlist();
      }, 300);
    }

    // Initialize swiper after products are rendered
    this.#initializeSwiper();
  }

  #initializeSwiper() {
    const swiperComponent = /** @type {any} */ (this.querySelector('swiper-component'));
    if (swiperComponent) {
      // Destroy existing swiper if it exists
      if (swiperComponent.swiper) {
        swiperComponent.swiper.destroy(true, true);
        swiperComponent.swiper = null;
      }

      // Wait for DOM to be ready and images to load
      setTimeout(() => {
        if (swiperComponent.swiper === null && typeof swiperComponent.init === 'function') {
          swiperComponent.init();
          if (swiperComponent.swiper) {
            const swiper = swiperComponent.swiper;
            if (swiper.params.initialSlide) {
              swiper.slideTo(swiper.params.initialSlide, 0);
            }

            // Set parameters
            swiper.params.spaceBetween = 14;
            swiper.params.watchOverflow = true;
            swiper.params.slidesPerGroup = 1;
            swiper.params.resistance = true;
            swiper.params.resistanceRatio = 0;
            swiper.params.allowTouchMove = true;
            swiper.params.centeredSlidesBounds = true;
            // swiper.params.slideToClickedSlide = true;            // Override pagination render to show correct number of bullets
            const slides = swiper.slides;
            const totalSlides = slides.length;
            const slidesPerView = swiper.params.slidesPerView;

            if (totalSlides > slidesPerView) {
              const maxIndex = Math.max(0, totalSlides - Math.ceil(slidesPerView));
              const totalBullets = maxIndex + 1;

              // Override pagination renderBullet to limit the number of bullets
              swiper.params.pagination.renderBullet = function (/** @type {number} */ index, /** @type {string} */ className) {
                // Only render bullets up to totalBullets
                if (index >= totalBullets) {
                  return '';
                }
                return '<span class="' + className + '"></span>';
              };

              // Update pagination
              if (swiper.pagination && swiper.pagination.render) {
                swiper.pagination.render();
                swiper.pagination.update();
              }
            }

            // Update swiper
            swiper.update();
            swiper.updateSlides();
            swiper.updateSlidesClasses();
            swiper.updateSize();
            swiper.updateSlidesClasses();

            // Force recalculation after a short delay to ensure images are loaded
            setTimeout(() => {
              swiper.update();
              swiper.updateSlides();
              swiper.updateSlidesClasses();
              swiper.updateSize();

              // Ensure we're at the beginning
              // swiper.slideTo(0, 0);

              // Calculate the correct number of pagination bullets and update
              const updatePagination = () => {
                const slides = swiper.slides;
                const totalSlides = slides.length;
                const slidesPerView = swiper.params.slidesPerView;

                if (totalSlides <= slidesPerView) {
                  // All slides fit, hide pagination
                  const paginationEl = swiper.pagination.el;
                  if (paginationEl) {
                    paginationEl.style.display = 'none';
                  }
                  return;
                }

                // Calculate maximum navigable index
                // With slidesPerView: 5 and 6 slides, we can navigate to:
                // - Index 0: shows slides 0-4
                // - Index 1: shows slides 1-5 (includes last slide)
                // So maxIndex = totalSlides - Math.ceil(slidesPerView)
                const maxIndex = Math.max(0, totalSlides - Math.ceil(slidesPerView));
                // Number of pagination bullets = number of navigable positions = maxIndex + 1
                const totalBullets = maxIndex + 1;

                // Get current pagination bullets
                const paginationEl = swiper.pagination.el;
                if (!paginationEl) return;

                paginationEl.style.display = 'block';
                const currentBullets = paginationEl.querySelectorAll('.swiper-pagination-bullet');
                const currentCount = currentBullets.length;

                // If we have the wrong number of bullets, force Swiper to re-render
                if (currentCount !== totalBullets) {
                  // Re-render pagination with the correct renderBullet function
                  if (swiper.pagination && swiper.pagination.render) {
                    swiper.pagination.render();
                    swiper.pagination.update();
                  }
                } else {
                  // Just update active state
                  const activeIndex = Math.min(swiper.activeIndex, maxIndex);
                  const bullets = paginationEl.querySelectorAll('.swiper-pagination-bullet');
                  bullets.forEach((/** @type {HTMLElement} */ bullet, /** @type {number} */ index) => {
                    if (index === activeIndex) {
                      bullet.classList.add('swiper-pagination-bullet-active');
                    } else {
                      bullet.classList.remove('swiper-pagination-bullet-active');
                    }
                  });
                }
              };

              // Calculate max translate using Swiper's native calculation
              const getMaxTranslate = () => {
                // Swiper uses negative values for translate (slides move left)
                // The max translate is the most negative value we can go
                const slides = swiper.slides;
                const totalSlides = slides.length;
                const slidesPerView = swiper.params.slidesPerView;

                if (totalSlides <= slidesPerView) {
                  return 0; // All slides fit, no scrolling needed
                }

                // Use Swiper's internal calculation
                // Max translate = -(total width of slides - visible width)
                const wrapper = swiper.wrapperEl;
                const containerWidth = swiper.width;
                const wrapperWidth = wrapper.scrollWidth;

                // Calculate the maximum translate (negative value)
                const maxTranslate = -(wrapperWidth - containerWidth);

                return maxTranslate;
              };

              // Override setTranslate to clamp the value
              const originalSetTranslate = swiper.setTranslate.bind(swiper);
              swiper.setTranslate = function (/** @type {number} */ translate) {
                const maxTranslate = getMaxTranslate();
                // Clamp translate: it should be between maxTranslate (most negative) and 0
                const clampedTranslate = Math.max(maxTranslate, Math.min(0, translate));
                originalSetTranslate(clampedTranslate);
              };

              // Override setWrapperTranslate to prevent going past the end.
              // Guard for Swiper versions where this internal method is unavailable.
              if (typeof swiper.setWrapperTranslate === 'function') {
                const originalSetWrapperTranslate = swiper.setWrapperTranslate.bind(swiper);
                swiper.setWrapperTranslate = function (/** @type {number} */ translate) {
                  const maxTranslate = getMaxTranslate();
                  const clampedTranslate = Math.max(maxTranslate, Math.min(0, translate));
                  originalSetWrapperTranslate(clampedTranslate);
                };
              }

              // Add event listener to prevent scrolling past the last slide
              swiper.on('slideChange', () => {
                const slides = swiper.slides;
                const currentIndex = swiper.activeIndex;
                const slidesPerView = swiper.params.slidesPerView;
                const totalSlides = slides.length;

                if (totalSlides <= slidesPerView) {
                  updatePagination();
                  return; // All slides visible, no need to check
                }

                // Calculate if we're at or past the last valid slide
                const maxIndex = Math.max(0, totalSlides - Math.ceil(slidesPerView));

                // If we've scrolled past the last valid position, snap back
                if (currentIndex > maxIndex) {
                  swiper.slideTo(maxIndex, 300);
                }

                // Update pagination to reflect current position
                updatePagination();
              });

              // Prevent touch from going past the end during drag
              swiper.on('touchMove', () => {
                const maxTranslate = getMaxTranslate();
                if (swiper.translate < maxTranslate) {
                  swiper.setTranslate(maxTranslate);
                }
              });

              // Also prevent on touch end
              swiper.on('touchEnd', () => {
                const maxTranslate = getMaxTranslate();
                if (swiper.translate < maxTranslate) {
                  swiper.setTranslate(maxTranslate);
                  swiper.updateSlidesClasses();
                }
              });

              // Prevent navigation button from going past the end
              const originalSlideNext = swiper.slideNext.bind(swiper);
              swiper.slideNext = function () {
                const slides = swiper.slides;
                const slidesPerView = swiper.params.slidesPerView;
                const totalSlides = slides.length;
                const maxIndex = Math.max(0, totalSlides - Math.ceil(slidesPerView));

                if (swiper.activeIndex < maxIndex) {
                  originalSlideNext();
                }
              };

              // Handle resize to recalculate
              let /** @type {ReturnType<typeof setTimeout> | undefined} */ resizeTimeout;
              const handleResize = () => {
                if (resizeTimeout) clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(() => {
                  swiper.update();
                  swiper.updateSlides();
                  swiper.updateSlidesClasses();
                  swiper.updateSize();

                  // Ensure we don't go past the end after resize
                  const maxTranslate = getMaxTranslate();
                  if (swiper.translate < maxTranslate) {
                    swiper.setTranslate(maxTranslate);
                    swiper.updateSlidesClasses();
                  }

                  // Update pagination after resize
                  updatePagination();
                }, 250);
              };
              window.addEventListener('resize', handleResize);

              // Also listen for Swiper's reachEnd event
              swiper.on('reachEnd', () => {
                const maxTranslate = getMaxTranslate();
                if (swiper.translate < maxTranslate) {
                  swiper.setTranslate(maxTranslate);
                  swiper.updateSlidesClasses();
                }
              });

              // Update pagination after initialization
              updatePagination();

              // Update pagination on slide change to ensure correct active bullet
              swiper.on('slideChange', () => {
                updatePagination();
              });

              // Update after images load
              const images = swiper.el.querySelectorAll('img');
              let imagesLoaded = 0;
              const totalImages = images.length;

              if (totalImages > 0) {
                images.forEach((/** @type {HTMLImageElement} */ img) => {
                  if (img.complete) {
                    imagesLoaded++;
                  } else {
                    img.addEventListener('load', () => {
                      imagesLoaded++;
                      if (imagesLoaded === totalImages) {
                        swiper.update();
                        swiper.updateSlides();
                        swiper.updateSlidesClasses();
                        swiper.updateSize();
                        updatePagination();
                      }
                    });
                  }
                });

                if (imagesLoaded === totalImages) {
                  swiper.update();
                  swiper.updateSlides();
                  swiper.updateSlidesClasses();
                  swiper.updateSize();
                  updatePagination();
                }
              }
            }, 200);
          }
        }
      }, 200);
    }
  }

  /**
   * @param {any} product
   * @returns {HTMLElement}
   */
  #createProductCard(product) {
    let cardCon = document.createElement('div');

    cardCon.innerHTML = `
<neo-product-card-1 class="neo-product-card-1"
  data-product-id="${product.productId}"
  data-enable-swiper="false"
  data-enable-pagination="false"
>

<div class="neo-product-card-details">

<a class="title-container" href="/products/${product.handle}">

<h2 class="visually-hidden">${product.title}</h2>

${product.title ? `
<p class="neo-product-card-title line-clamp-2 min-height">
${product.title}
</p>
` : ``}

${product.highlights ? `
<p class="neo-product-card-sub-title line-clamp-2 min-height">
${product.highlights}
</p>
` : ``}
</a>


${product.productId && product.variantId ? `
<div class="neo-product-card-wishlist">
<span
class="smartwishlist"
data-product="${product.productId}"
data-variant="${product.variantId}"
></span>
</div>
` : ``}

</div>


${product.watchGifSrc ? `
<div class="neo-product-card-1-watch-gif-container">
<div class="relative">

<img
src="${product.watchGifSrc}"
alt="${product.title}"
class="neo-product-card-1-watch-gif"
loading="lazy"
/>

<svg class="neo-product-card-1-watch-play-icon" width="7" height="8" viewBox="0 0 7 8">
<path d="M0 7.08734V0.735669C0 0.149096 0.653735 -0.200773 1.14179 0.124599L5.90983 3.30329C6.36248 3.60505 6.36248 4.27019 5.90983 4.57195L1.18526 7.72167C0.67862 8.05943 0 7.69624 0 7.08734Z" fill="white"/>
</svg>

</div>

<p class="neo-product-card-1-watch-gif-text">Watch</p>

</div>
` : ``}


${product.colorSwatches?.length ? `
  <div class="color-variant-images">
  ${product.colorSwatches.slice(0, 4).map(swatch => `
  <img
  src="${swatch.url + (swatch.url.includes('?') ? '&' : '?') + 'width=100'}"
  alt="${swatch.alt}"
  class="neo-product-card-color-variant-image"
  loading="lazy"
  />
  `).join("")}
  </div>
  ` : ``}

${product.image?.url || product.imageTag || product.variantId ? `
<div class="neo-product-card-media-container">

${product.imageTag ? `
<p class="neo-product-card-new-tag">
${product.imageTag}
</p>
` : ``}
${product.saleImageTag ? `
<p class="neo-product-card-sale-tag">Sale</p>
` : ``}

<div class="neo-product-card-media">

${product.image?.url ? `
<div class="swiper">
<div class="swiper-wrapper">

<div class="swiper-slide">


<a class="image-container neo-product-card-media--link" href="/products/${product.handle}">
<img
src="${product.image.url}"
alt="${product.image.altText || product.title}"
width="${product.image.width || ""}"
height="${product.image.height || ""}"
class="neo-product-card-1__image-img"
/>
</a>

</div>

</div>
</div>
` : ``}

${product.tag ? `
<p class="neo-product-card-1-tag">
${product.tag}
</p>
` : ``}

</div>

${product.variantId ? `
<button class="add-to-cart-button-gql cursor-pointer" data-product-id="${product.productId}" data-variant-id="${product.variantId}" onclick="ATBModalOpen(event, '${product.productId}');
document.querySelector('cart-drawer-component').close();">
${window.AtcPriceBlock ? window.AtcPriceBlock.html(product.price, product.compareAtPrice) : `<span>${this.#formatPrice(product.price, product.currencyCode)}</span>`}
<span>|</span>
${window.AtcPriceBlock && window.AtcPriceBlock.ctaPlusHtml ? window.AtcPriceBlock.ctaPlusHtml() : '<span class="add-to-cart-button-gql-plus"><span class="add-to-cart-button-gql-plus-icon">+</span><span class="add-to-cart-button-gql-label">Add</span></span>'}

<span class="atc-link-button__corner atc-link-button__corner--tl">
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
    <mask id="corner-mask-tl" fill="white">
    <path d="M0 2C0 0.895431 0.895431 0 2 0H6C7.10457 0 8 0.895431 8 2V6C8 7.10457 7.10457 8 6 8H2C0.895431 8 0 7.10457 0 6V2Z" />
    </mask>
    <path d="M-0.5 2C-0.5 0.619288 0.619288 -0.5 2 -0.5H5.5C6.88071 -0.5 8 0.619288 8 2C8 1.17157 7.10457 0.5 6 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2H-0.5ZM8 8H0H8ZM2 8C0.619288 8 -0.5 6.88071 -0.5 5.5V2C-0.5 0.619288 0.619288 -0.5 2 -0.5V0.5C1.17157 0.5 0.5 1.17157 0.5 2V6C0.5 7.10457 1.17157 8 2 8ZM8 0V8V0Z" fill="#ffffff" mask="url(#corner-mask-tl)" />
  </svg>
</span>

<span class="atc-link-button__corner atc-link-button__corner--tr">
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
    <mask id="corner-mask-tl" fill="white">
    <path d="M0 2C0 0.895431 0.895431 0 2 0H6C7.10457 0 8 0.895431 8 2V6C8 7.10457 7.10457 8 6 8H2C0.895431 0 0 7.10457 0 6V2Z" />
    </mask>
    <path d="M-0.5 2C-0.5 0.619288 0.619288 -0.5 2 -0.5H5.5C6.88071 -0.5 8 0.619288 8 2C8 1.17157 7.10457 0.5 6 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2H-0.5ZM8 8H0H8ZM2 8C0.619288 8 -0.5 6.88071 -0.5 5.5V2C-0.5 0.619288 0.619288 -0.5 2 -0.5V0.5C1.17157 0.5 0.5 1.17157 0.5 2V6C0.5 7.10457 1.17157 8 2 8ZM8 0V8V0Z" fill="#ffffff" mask="url(#corner-mask-tl)" />
  </svg>
</span>
<span class="atc-link-button__corner atc-link-button__corner--bl">
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
    <mask id="corner-mask-tl" fill="white">
    <path d="M0 2C0 0.895431 0.895431 0 2 0H6C7.10457 0 8 0.895431 8 2V6C8 7.10457 7.10457 8 6 8H2C0.895431 8 0 7.10457 0 6V2Z" />
    </mask>
    <path d="M-0.5 2C-0.5 0.619288 0.619288 -0.5 2 -0.5H5.5C6.88071 -0.5 8 0.619288 8 2C8 1.17157 7.10457 0.5 6 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2H-0.5ZM8 8H0H8ZM2 8C0.619288 8 -0.5 6.88071 -0.5 5.5V2C-0.5 0.619288 0.619288 -0.5 2 -0.5V0.5C1.17157 0.5 0.5 1.17157 0.5 2V6C0.5 7.10457 1.17157 8 2 8ZM8 0V8V0Z" fill="#ffffff" mask="url(#corner-mask-tl)" />
  </svg>
</span>

<span class="atc-link-button__corner atc-link-button__corner--br">
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
    <mask id="corner-mask-tl" fill="white">
    <path d="M0 2C0 0.895431 0.895431 0 2 0H6C7.10457 0 8 0.895431 8 2V6C8 7.10457 7.10457 8 6 8H2C0.895431 0 0 7.10457 0 6V2Z" />
    </mask>
    <path d="M-0.5 2C-0.5 0.619288 0.619288 -0.5 2 -0.5H5.5C6.88071 -0.5 8 0.619288 8 2C8 1.17157 7.10457 0.5 6 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2H-0.5ZM8 8H0H8ZM2 8C0.619288 8 -0.5 6.88071 -0.5 5.5V2C-0.5 0.619288 0.619288 -0.5 2 -0.5V0.5C1.17157 0.5 0.5 1.17157 0.5 2V6C0.5 7.10457 1.17157 8 2 8ZM8 0V8V0Z" fill="#ffffff" mask="url(#corner-mask-tl)" />
  </svg>
</span>
</button>
` : ``}

</div>
` : ``}

</neo-product-card-1>
`;

    return cardCon;








    // const card = document.createElement('neo-product-card-1');
    // card.className = 'neo-product-card-1';
    // card.dataset.productId = product.productId;

    // // Attach media data attributes used by the neo-product-card-1 custom element
    // // if (product.productMediaJson) {
    // //   card.setAttribute('data-product-media', product.productMediaJson);
    // // }
    // if (product.watchGifSrc) {
    //   card.setAttribute('data-product-watch-gif-src', String(product.watchGifSrc).replace(/"/g, '&quot;'));
    // }
    // if (product.videoPreviewUrl) {
    //   card.setAttribute('data-product-video-preview-image-url', String(product.videoPreviewUrl).replace(/"/g, '&quot;'));
    // }
    // if (product.videoSourceUrl) {
    //   card.setAttribute('data-product-video-source-url', String(product.videoSourceUrl).replace(/"/g, '&quot;'));
    // }

    // const productUrl = `/products/${product.handle}`;
    // const imageUrl = product.image?.url || '';
    // const imageAlt = this.#escapeHtml(product.image?.altText || product.title);
    // const formattedPrice = this.#formatPrice(product.price, product.currencyCode);
    // const title = this.#escapeHtml(product.title);
    // const highlights = product.highlights ? this.#escapeHtml(product.highlights) : '';
    // const tag = product.tag ? this.#escapeHtml(product.tag) : '';

    // const colorSwatches = Array.isArray(product.colorSwatches) ? product.colorSwatches : [];
    // const colorSwatchesHtml = colorSwatches.length
    //   ? colorSwatches
    //       .map((sw) => {
    //         const rawUrl = sw.url || '';
    //         const separator = rawUrl.includes('?') ? '&' : '?';
    //         const swUrl = `${rawUrl}${separator}width=100`;
    //         const altText = (sw.alt || product.title || '').replace(/"/g, '&quot;');
    //         return `<img src="${swUrl}" alt="${altText}" class="neo-product-card-color-variant-image" loading="lazy">`;
    //       })
    //       .join('')
    //   : `
    //       <span class="neo-product-card-color-skeleton" aria-hidden="true"></span>
    //       <span class="neo-product-card-color-skeleton" aria-hidden="true"></span>
    //       <span class="neo-product-card-color-skeleton" aria-hidden="true"></span>
    //       <span class="neo-product-card-color-skeleton" aria-hidden="true"></span>
    //     `;

    // const showWatchGif = product.hasProductVideo && product.watchGifSrc;
    // const watchGifBlock = showWatchGif
    //   ? `<div class="neo-product-card-1-watch-gif-container">
    //       <div class="relative">
    //         <img src="${String(product.watchGifSrc) + (String(product.watchGifSrc).includes('?') ? '&' : '?') + 'width=100'}" alt="${title}" class="neo-product-card-1-watch-gif" loading="lazy">
    //         ${NEO_PLAY_ICON_SVG}
    //       </div>
    //       <p class="neo-product-card-1-watch-gif-text">Watch</p>
    //     </div>`
    //   : '';

    // const cornerSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none"><mask id="path-1-inside-1_6289_29312" fill="white"><path d="M0 2C0 0.895431 0.895431 0 2 0H6C7.10457 0 8 0.895431 8 2V6C8 7.10457 7.10457 8 6 8H2C0.895431 8 0 7.10457 0 6V2Z"/></mask><path d="M-0.5 2C-0.5 0.619288 0.619288 -0.5 2 -0.5H5.5C6.88071 -0.5 8 0.619288 8 2C8 1.17157 7.10457 0.5 6 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2H-0.5ZM8 8H0H8ZM2 8C0.619288 8 -0.5 6.88071 -0.5 5.5V2C-0.5 0.619288 0.619288 -0.5 2 -0.5V0.5C1.17157 0.5 0.5 1.17157 0.5 2V6C0.5 7.10457 1.17157 8 2 8ZM8 0V8V0Z" fill="#ffffff" mask="url(#path-1-inside-1_6289_29312)"/></svg>`;

    // card.innerHTML = `
    //   <div class="neo-product-card-details">
    //     <a class="title-container" href="${productUrl}">
    //       <h2 class="visually-hidden">${title}</h2>
    //       <p class="neo-product-card-title line-clamp-2 min-height">${title}</p>
    //       <p class="neo-product-card-sub-title line-clamp-2 min-height">${highlights}</p>
    //     </a>
    //     <div class="neo-product-card-wishlist">
    //       <span
    //         class="smartwishlist"
    //         data-product="${product.productId}"
    //         data-variant="${product.variantId}"
    //       ></span>
    //     </div>
    //   </div>

    //   <div class="neo-product-card-media-container">
    //     <div class="color-variant-images">
    //       ${colorSwatchesHtml}
    //     </div>

    //     <div class="neo-product-card-media">
    //       ${watchGifBlock}
    //       <div class="swiper">
    //         <div class="swiper-wrapper">
    //           <div class="swiper-slide">
    //             <img
    //               src="${imageUrl}&width=520"
    //               alt="${imageAlt}"
    //               class="neo-product-card-1__image-img"
    //               loading="lazy"
    //               width="700"
    //             />
    //           </div>
    //         </div>
    //       </div>
    //       ${tag ? `<p class="neo-product-card-1-tag">${tag}</p>` : ''}
    //     </div>

    //     <button
    //       class="add-to-cart-button-gql"
    //       type="button"
    //       onclick="ATBModalOpen(event, '${product.productId}')"
    //       data-product-id="${product.productId}"
    //       data-color-variants-ids="${(product.colorVariantIds || '').replace(/"/g, '&quot;')}"
    //     >
    //       <span>${formattedPrice}</span>
    //       <span>|</span>
    //       <span class="add-to-cart-button-gql-plus">
    //         <span class="add-to-cart-button-gql-plus-icon">+</span>
    //         <span class="add-to-cart-button-gql-plus">
    //           <svg class="loading-svg" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><style>.spinner_aj0A{transform-origin:center;animation:spinner_KYSC .75s infinite linear}@keyframes spinner_KYSC{100%{transform:rotate(360deg)}}</style><path d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z" class="spinner_aj0A"></path></svg>
    //         </span>
    //         Add to Cart
    //       </span>
    //       <div class="corner-1">${cornerSvg}</div>
    //       <div class="corner-2">${cornerSvg}</div>
    //       <div class="corner-3">${cornerSvg}</div>
    //       <div class="corner-4">${cornerSvg}</div>
    //     </button>
    //   </div>
    // `;

    // return card;
  }

  /**
   * @param {number} amount
   * @param {string} currencyCode
   * @returns {string}
   */
  #formatPrice(price) {
  const formatted = new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price);

  return `₹ ${formatted}`;
}

  /**
   * @param {string} text
   * @returns {string}
   */
  #escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  /**
   * @param {string} variantId
   */
  #handleAddToCart(variantId) {
    if (!variantId) return;

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    // Get cart section IDs to update cart UI
    const cartSectionIds = [];
    const cartItemsComponents = document.querySelectorAll('cart-items-component, cart-drawer');
    cartItemsComponents.forEach((item) => {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        cartSectionIds.push(item.dataset.sectionId);
      }
    });

    // Add sections parameter if we have cart components
    if (cartSectionIds.length > 0) {
      formData.append('sections', cartSectionIds.join(','));
    }

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/json',
      },
    })
      .then(async (response) => {
        const data = await response.json();
        if (response.ok) {
          // If fetch is successful, run auditzyTrackingScript()
          try {
            if (typeof window !== 'undefined' && typeof window.auditzyTrackingScript === 'function') {
              window.auditzyTrackingScript();
            } else if (typeof auditzyTrackingScript === 'function') {
              auditzyTrackingScript();
            }
          } catch (err) {
            console.warn('auditzyTrackingScript failed:', err);
          }
        }
        // Dispatch CartAddEvent with sections data to update cart UI
        document.dispatchEvent(
          new CartAddEvent({}, '', {
            source: 'similar-products',
            variantId: variantId,
            itemCount: 1,
            sections: data.sections || {},
          })
        );
      })
      .catch(() => {
        console.error('Failed to add product to cart');
      });
  }

  #hideSection() {
    this.style.display = 'none';
  }
}

if (!customElements.get('similar-products')) {
  customElements.define('similar-products', SimilarProducts);
}



